import './hampshirehe4/style';
import FormStructure from './hampshirehe4/form_structure';

export default FormStructure;